import { useState } from 'react';
import EventEmitter, { EVENT_TYPES } from '@lib/eventEmitter';
import localStorageAvailable from '@javascript/helpers/localStorage';
import { useMultiSelect } from '@components/search_filters/hooks';

export function useSpecificationContainer(allowlist, specification) {
  const openModal = () => {
    EventEmitter.emit(EVENT_TYPES.openModal, 'vehicleSummary');
  };

  const closeModal = () => {
    EventEmitter.emit(EVENT_TYPES.closeModal);
  };

  const storedPreferences =
    localStorageAvailable() && localStorage.getItem('vehicleSummary')
      ? JSON.parse(localStorage.getItem('vehicleSummary'))
      : [];

  const [summaryDisplay, setSummaryDisplay] = useState([
    ...allowlist,
    ...storedPreferences,
  ]);

  const { selectedOptions: additionalSummaryDisplay, handleChange } =
    useMultiSelect(storedPreferences);

  const handleSubmit = () => {
    const updated = [...allowlist, ...additionalSummaryDisplay];
    localStorage.setItem('vehicleSummary', JSON.stringify(updated));
    setSummaryDisplay(updated);
    closeModal();
  };

  const pickerOptions = Object.keys(specification.summary).filter(
    (key) => !allowlist.includes(key),
  );

  const displaySummaryPicker = !!pickerOptions.length;

  return {
    additionalSummaryDisplay,
    closeModal,
    displaySummaryPicker,
    handleChange,
    handleSubmit,
    openModal,
    pickerOptions,
    summaryDisplay,
  };
}
